export enum TableViewType {
    EXPANDED,
    SHORTED
}
